import { ApplicationStore } from "src/store";
import { getCreditScoreDefault, isCalculateTaxesCustomerRequest } from "src/store/selectors/financeSettings";

export const getCreditScore = (state: ApplicationStore): number =>
    state.deal.person?.credit_estimate ?? getCreditScoreDefault(state);

export const getZipCode = (state: ApplicationStore) =>
    isCalculateTaxesCustomerRequest(state)
        ? state.deal.person?.zip
        : state.deal.person?.zip ?? state.account.address?.zip;

export const getZipCodeSource = (state: ApplicationStore) =>
    state.deal.person?.zip || isCalculateTaxesCustomerRequest(state) ? "user" : "dealer";

export const getFirstName = (state: ApplicationStore) => state.deal.person?.first_name || "";

export const getLastName = (state: ApplicationStore) => state.deal.person?.last_name || "";

export const getEmail = (state: ApplicationStore) => state.deal.person?.email;

export const getMobilePhone = (state: ApplicationStore) => state.deal.person?.mobile_phone;

export const getCanadianMarketingOptIn = (state: ApplicationStore) =>
    state.deal.person?.preferences?.opt_in_marketing ?? false;
